import { ActivityTickerAction } from './actions'
import { TickerInfo } from './types'

export interface State {
  tickerInfo?: TickerInfo[]
  pending: boolean
  error: boolean
}

export const initialState: State = {
  tickerInfo: undefined,
  pending: true,
  error: false
}

export default (state = initialState, action: ActivityTickerAction): State => {
  switch (action.type) {
    case 'activityticker.success':
      let items: TickerInfo[] = []

      if ('payload' in action) {
        items = action.payload ?? []
      }

      if (!state.tickerInfo) {
        return {
          ...state,
          tickerInfo: items
        }
      }

      return {
        ...state,
        tickerInfo: [...state.tickerInfo, ...items]
      }

    case 'activityticker.fetch':
      return {
        ...state,
        pending: true,
        tickerInfo: undefined,
        error: false
      }
    case 'activityticker.fetchFail':
      return {
        ...state,
        pending: false,
        error: true
      }
    default:
      return state
  }
}
